import { Components as JoyComponents, Theme as JoyTheme } from '@mui/joy';
import JoyCard from '@mui/joy/Card';
import JoyCardActions from '@mui/joy/CardActions';
import JoyCardContent from '@mui/joy/CardContent';
import JoyCardCover from '@mui/joy/CardCover';
import JoyCardOverflow, { CardOverflowProps } from '@mui/joy/CardOverflow';

export const overrides: JoyComponents<JoyTheme> = {
  JoyCard: {
    defaultProps: {
      size: 'lg',
    },
    styleOverrides: {
      root: ({ theme }) => ({
        '--Card-radius': theme.radius.md,
      }),
    },
  },
};

export const Card = JoyCard;
export const CardActions = JoyCardActions;
export const CardOverflow = ({
  bleed = false,
  ...props
}: CardOverflowProps & { bleed?: boolean }) => {
  return (
    <JoyCardOverflow
      {...props}
      sx={{
        ...(props.sx || {}),
        ...(bleed && { p: 0 }),
      }}
    />
  );
};
export const CardContent = JoyCardContent;
export const CardCover = JoyCardCover;
